import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { AmsPartsProvider } from '../../contexts';
import { SidebarLayout } from '../../layouts';
import { PermissionsGuard } from './Components';
import { Loader } from './loader.routes';

const AmsPartsList = Loader(lazy(() => import('../pages/AmsParts')));
const AmsPartBulkCreate = Loader(lazy(() => import('../pages/AmsParts/AmsPartBulk/AmsPartBulkCreate')));

export const createAmsPartsRoutes = () => ({
  path: 'ams',
  element: <SidebarLayout />,
  children: [
    {
      path: '',
      element: (
        <PermissionsGuard allowedPermissions={['amsPartsViewAll']} should404>
          <Navigate to="/ams/list" replace />
        </PermissionsGuard>
      )
    },
    {
      path: 'list',
      element: (
        <PermissionsGuard allowedPermissions={['amsPartsViewAll']} should404>
          <AmsPartsProvider>
            <AmsPartsList />
          </AmsPartsProvider>
        </PermissionsGuard>
      )
    },
    {
      path: 'bulk-create',
      element: (
        <PermissionsGuard allowedPermissions={['amsPartsCreate']} should404>
          <AmsPartBulkCreate />
        </PermissionsGuard>
      )
    }
  ]
});
